import type { IFilterBadge } from '@/components/FilterBadgesList';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import Modal from '@/components/UI/Modal';
import type { QueryParamsInterface } from '@/types/Shared';

interface FBDIFiltersFormProps {
  handleModal: () => void;
  handleApplyFilter: (filterData: QueryParamsInterface, filterBadgesData: IFilterBadge) => void;
}

export interface StatusList {
  label: string;
  value: string;
}

const statusChangeList: StatusList[] = [
  { label: 'Submitted', value: 'SUBMITTED' },
  { label: 'Document Requested', value: 'DOCUMENT_REQUESTED' },
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Under Review', value: 'UNDER_REVIEW' },
];

const FBDIFiltersBaseForm = ({ handleModal, handleApplyFilter }: FBDIFiltersFormProps) => {
  const onSubmit = (formData: { status: StatusList }) => {
    const applyFiltersData = {
      ...(formData?.status && { status: formData?.status?.value }),
    };

    const filterBadgesData = {
      ...(formData?.status && {
        status: { label: 'Status', value: formData?.status?.label },
      }),
    };
    handleApplyFilter(applyFiltersData, filterBadgesData);
  };
  return (
    <HookForm onSubmit={onSubmit}>
      <h2 className='m-0'>Application Filters</h2>
      <dl className='my-5 space-y-5'>
        <div className='flex w-full justify-between items-center'>
          <dt>Status</dt>
          <dd className='w-2/3'>
            <HookReactSingleSelect name='status' options={statusChangeList} isClearable />
          </dd>
        </div>
      </dl>
      <div className='flex gap-4 justify-end pt-5'>
        <Button label='Cancel' btnStyle='neutral' type='button' onClick={handleModal} />
        <Button label='Apply' btnStyle='primary' type='submit' />
      </div>
    </HookForm>
  );
};

export const FBDIFiltersForm = (props: FBDIFiltersFormProps) => {
  return (
    <Modal customStyle='overflow-visible'>
      <HookFormProvider>
        <FBDIFiltersBaseForm {...props} />
      </HookFormProvider>
    </Modal>
  );
};
